import React, { ReactElement } from 'react';
import { createRoot } from 'react-dom/client';
import { HashRouter as Router } from 'react-router-dom';
import './styles/styles.scss';
import App from './App/App';
import './Translation/i18n';
import reportWebVitals from './reportWebVitals';
import { AuthContextProvider } from './contexts/authContext';
import './i18n';
import { UserRoleProvider } from './contexts/userRoleContext';
import { AlertsProvider } from './contexts/alertsContext';
import { ENV, ENV_PROD } from './constants/environment.constants';

const children: ReactElement = (
	<AuthContextProvider>
		<UserRoleProvider>
			<AlertsProvider>
				<Router>
					<App />
				</Router>
			</AlertsProvider>
		</UserRoleProvider>
	</AuthContextProvider>
);

if (ENV === ENV_PROD) {
 	console.log = (): void => {};
 	console.info = (): void => {};
 	console.debug = (): void => {};
 	console.dir = (): void => {};
 	console.warn = (): void => {};
 	console.error = (): void => {};
 	console.trace = (): void => {};
}

const container: HTMLElement | null = document.getElementById('root');

createRoot(container as HTMLElement).render(children);

reportWebVitals();
